import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-[#1a1a2e] text-white py-12">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/a19dd0a56f3d184158c62a348fccb582/f2eae84610da25ffff8cb3de975ca611.png" 
              alt="APL Consultoria" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-400 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.servicesTitle')}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#servicos" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  {t('services.inmetro.title')}
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  {t('services.anatel.title')}
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  {t('services.anvisa.title')}
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  {t('services.consulting.title')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.contactTitle')}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-orange-500"></i>
                <a href="tel:+5521993197442" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                  (21) 99319-7442
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-orange-500 mt-1"></i>
                <a href="mailto:comercial@aplconsulttec.com.br" className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer break-all">
                  comercial@aplconsulttec.com.br
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer.hoursTitle')}</h4>
            <p className="text-gray-400 leading-relaxed whitespace-pre-line">
              {t('footer.hoursValue')}
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            {t('footer.copyright')}
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-400 hover:text-orange-500 transition-colors text-sm cursor-pointer"
          >
            {t('footer.poweredBy')}
          </a>
        </div>
      </div>
    </footer>
  );
}
